import { useLazyGetPreviewUrlQuery } from "store/apis/previewUrl";
import { openDownloadUrl } from "util/openDownloadUrl";
import { BackendError } from "types/utils/error";
import { useToast } from "hooks/useToast";

export const useDownloadFile = () => {
  const [getPreviewUrl, result] = useLazyGetPreviewUrlQuery();
  const { alertToast } = useToast();

  const downloadFile = async ({
    file_id,
    group_id,
  }: {
    file_id: string;
    group_id: string;
  }) => {
    try {
      const { download_url } = await getPreviewUrl({
        groupId: group_id,
        fileId: file_id,
      }).unwrap();
      openDownloadUrl(download_url);
    } catch (error) {
      alertToast(
        {
          message: (error as BackendError)?.data?.error?.message,
        },
        error as Error
      );
    }
  };

  return { downloadFile, result };
};
